import React from "react";
import "./App.css";
import ToNavigate from "./ToNavigate.js";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <header>GraphWiz</header>
        <ToNavigate className="App-navigate" />
      </header>
    </div>
  );
}

export default App;
